import get from 'lodash/get';
import defaultFields from 'store/Services/fields';

const selectAssetServicesFields = (state) => {
  const fields = get(state, 'preferences.services_table', defaultFields);
  const excludedFields = ['asset', 'workspace_name'];

  const newFields = {};
  Object.keys(defaultFields).forEach((key) => {
    if (!excludedFields.includes(key)) {
      const defaultField = defaultFields[key];
      newFields[key] = { ...defaultField, ...get(fields, key, defaultField) };
    }
  });

  return newFields;
};

export default selectAssetServicesFields;
